(function () {
  'use strict';

  function setOpen(item, open) {
    var trigger = item.querySelector('[data-accordion-trigger]');
    if (open) {
      item.setAttribute('data-open', '');
    } else {
      item.removeAttribute('data-open');
    }
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function toggle(trigger) {
    var item = trigger.closest('[data-accordion-item]');
    if (!item) return;
    var willOpen = !item.hasAttribute('data-open');

    var group = trigger.closest('[data-accordion-single]');
    if (group && willOpen) {
      group.querySelectorAll('[data-accordion-item][data-open]').forEach(function (open) {
        if (open !== item) setOpen(open, false);
      });
    }
    setOpen(item, willOpen);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-accordion-trigger]');
    if (!trigger) return;
    event.preventDefault();
    toggle(trigger);
  });
})();
